import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { FilterBar, useFilterBarStyles } from '../ui';
import { Stories } from '../../store/slices';
import {
    STORY_OCCASION_OPTIONS, STORY_PRODUCT_OPTIONS, STORY_PUBLISHED_OPTIONS, STORY_RECIPIENT_OPTIONS, STORY_STATUS_OPTIONS,
} from '../../lib/storyOptions';

interface StoriesFiltersProps {
    queryParams: any;
    loadStories: (params?: any) => void;
    loading: boolean;
}

/** Filters of the stories list; every change reloads page 1. "Any" clears one filter, "Clear filters" all of them. */
export default function StoriesFilters({ queryParams, loadStories, loading }: StoriesFiltersProps) {
    const dispatch = useDispatch();
    const classes = useFilterBarStyles();

    const handleFilterChange = (name: string, value: unknown) => {
        loadStories({ ...queryParams, page: 1, [name]: value });
    };

    const select = (name: string, label: string, options: readonly { title?: string; label?: string; value: number | string; id?: number }[]) => (
        <FormControl key={name} className={classes.select} size="small">
            <InputLabel id={`stories-${name}-label`}>{label}</InputLabel>
            <Select
                labelId={`stories-${name}-label`}
                label={label}
                name={name}
                value={queryParams?.[name] ?? ''}
                disabled={loading}
                onChange={(event) => handleFilterChange(name, event.target.value)}
            >
                <MenuItem value="">Any</MenuItem>
                {options.map((option) => (
                    <MenuItem key={`${option.value}${option.title ?? option.label}`} value={option.value}>{option.title ?? option.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );

    return (
        <FilterBar label="Story filters">
            {select('isPublished', 'Published', STORY_PUBLISHED_OPTIONS)}
            {select('statusId', 'Status', STORY_STATUS_OPTIONS.map((status) => ({ title: status.label, value: status.id })))}
            {select('occasionId', 'Occasion', STORY_OCCASION_OPTIONS)}
            {select('recipientId', 'Recipient', STORY_RECIPIENT_OPTIONS)}
            {select('productId', 'Product', STORY_PRODUCT_OPTIONS)}
            <Button
                className={classes.clear}
                variant="text"
                size="small"
                disabled={loading}
                onClick={() => {
                    dispatch(Stories.clearFilters());
                    loadStories();
                }}
            >
                Clear filters
            </Button>
        </FilterBar>
    );
}
